/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener(
      "dispatch:cart-drawer:open",
      this.openDrawerViaEventHandler
    );
    document.addEventListener(
      "dispatch:cart-drawer:close",
      this.closeDrawerViaEventHandler
    );
    document.addEventListener(
      "dispatch:cart-drawer:refresh",
      this.cartRefreshHandler
    );
    this.addEventListener("on:cart-drawer:before-open", () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
    });
    this.addEventListener("on:cart:after-merge", () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll("cc-cart-cross-sell").forEach((el) => el.init());
      if (this.hasAttribute("open")) {
        this.focusIntoDrawer();
      }
    });
  }

  disconnectedCallback() {
    document.removeEventListener(
      "dispatch:cart-drawer:refresh",
      this.cartRefreshHandler
    );
    document.removeEventListener(
      "dispatch:cart-drawer:open",
      this.openDrawerViaEventHandler
    );
    document.removeEventListener(
      "dispatch:cart-drawer:close",
      this.closeDrawerViaEventHandler
    );
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector("cart-form").refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector("cart-form").refreshFromHtml(html);
  }

  /**
   * Opens the cart drawer and shifts focus inside
   * @param {Element} [opener] - Element that triggered opening.
   * @param {Element} [elementToFocus] - Element to focus after opening.
   * @param {Function} [callback] - Callback function.
   */
  open(opener, elementToFocus, callback) {
    if (!opener) {
      opener = this.lastOpener || (document.activeElement && document.activeElement !== document.body ? document.activeElement : null);
    }
    if (opener) {
      this.lastOpener = opener;
      if (typeof opener.setAttribute === "function") {
        opener.setAttribute("aria-expanded", "true");
      }
    }

    const targetToFocus = elementToFocus ||
      this.querySelector(".cart-drawer__content:not(.cart-drawer__content--hidden) .drawer__close-btn") ||
      this.querySelector(".drawer__close-btn:not([hidden])") ||
      this.querySelector(".js-close-drawer") ||
      this.querySelector('button:not([disabled]), [tabindex="0"]') ||
      this;

    super.open(opener, targetToFocus, callback);

    this.focusIntoDrawer(targetToFocus);
  }

  /**
   * Shifts keyboard and screen reader focus securely into the drawer
   * @param {Element} [target] - Optional specific element to focus.
   */
  focusIntoDrawer(target) {
    const doFocus = () => {
      if (!this.hasAttribute("open")) return;
      const el = target ||
        this.querySelector(".cart-drawer__content:not(.cart-drawer__content--hidden) .drawer__close-btn") ||
        this.querySelector(".drawer__close-btn:not([hidden])") ||
        this.querySelector(".js-close-drawer") ||
        this.querySelector('button:not([disabled]), [tabindex="0"]') ||
        this;
      if (el && typeof el.focus === "function") {
        el.focus({ preventScroll: true });
      }
    };

    doFocus();
    requestAnimationFrame(doFocus);
    setTimeout(doFocus, 50);
    setTimeout(doFocus, 150);
    setTimeout(doFocus, 350);
  }

  /**
   * Closes the drawer and resets opener accessibility state
   * @param {Function} [callback] - Callback function.
   */
  close(callback) {
    const opener = this.opener || this.lastOpener;
    if (opener && typeof opener.setAttribute === "function") {
      opener.setAttribute("aria-expanded", "false");
    }
    super.close(callback);
  }
}

window.customElements.define("cart-drawer", CartDrawer);

// document.addEventListener('DOMContentLoaded', function () {
// Get all variant selects on the page

// var cart_drawer_icon = document.querySelector(".cart-link");
// var cart_drawer_open = document.querySelector("cart-drawer[open]");

// cart_drawer_icon.addEventListener('click', function(){

//     setTimeout(() => {

//     document.querySelectorAll('.upsell-select').forEach(function (select) {

//       select.addEventListener('change', function (e) {
//         const selectedVariantId = this.value;

//         // Find the parent form
//         const form = this.closest('.upsell-form');
//       console.log("selectedVariantId===",selectedVariantId);
//         if (form) {
//           // Find the hidden input inside this form and update its value
//           const hiddenInput = form.querySelector('input[type="hidden"][name="id"]');
//           if (hiddenInput) {
//             hiddenInput.value = selectedVariantId;
//           }
//         }
//       });
//     });
//   }, 1000);

// });

// document.addEventListener("DOMContentLoaded", function () {
//   var cart_form_ele = document.querySelector("cart-form");
//   console.log("cart-form====", cart_form_ele);

//   const cartDrawerTrigger = document.querySelector(".cart-link");

//   // Open cart drawer and attach upsell listeners
//   cartDrawerTrigger.addEventListener("click", function () {
//     setTimeout(() => {
//       start1();
      
//       function start1(){
      
//       document.querySelectorAll(".upsell-select").forEach(function (select) {
//         select.addEventListener("change", function () {
//           const selectedVariantId = this.value;
//           const form = this.closest(".upsell-form");
//           console.log("form---", form);
//           if (form) {
//             const hiddenInput = form.querySelector(
//               'input[type="hidden"][name="id"]'
//             );
//             if (hiddenInput) hiddenInput.value = selectedVariantId;
//           }
//         });
//       });

//         start2();
//       }
//       // Attach AJAX submission to upsell forms
//       // document.addEventListener("DOMContentLoaded", function () {
      
      

//       function start2(){
        
//       document.querySelectorAll(".upsell-form").forEach(function (form) {
//         const submitButton = form.querySelector(".upsell-add-btn");
//         console.log("submitButton--", submitButton);
//         if (submitButton) {
//           submitButton.addEventListener("click", function (e) {
//             e.preventDefault();

//             const formData = new FormData(form);

//             fetch("/cart/add.js", {
//               method: "POST",
//               headers: {
//                 Accept: "application/json",
//               },
//               body: formData,
//             })
//               .then((response) => {
//                 if (!response.ok) throw new Error("Add to cart failed");
//                 return response.json();
//               })
//               .then((data) => {
//                 console.log("Upsell product added:", data);
//                 cart_form_ele.boundRefresh();
//                 start1();
//                 // Now reload the cart drawer section HTML
//               })
//               .catch((error) => {
//                 console.error("Error adding upsell product:", error);
//               });
//           });
//         }
//       });
//       }
        
//       // });
//     }, 1000);
//   });
// });


document.addEventListener("DOMContentLoaded", function () {
  const cartDrawerTrigger = document.querySelector(".cart-link");
  const cartDrawer = document.querySelector("cart-drawer");

  if (!cartDrawerTrigger || !cartDrawer) return;

  let lastFocusedElement = null;

  function focusCartDrawer() {
    setTimeout(function () {
      if (cartDrawer.getAttribute("aria-hidden") === "false") {
        cartDrawer.focus();
      }
    }, 100);
  }

  function focusCartTrigger() {
    setTimeout(function () {
      if (cartDrawer.getAttribute("aria-hidden") === "true") {
        cartDrawerTrigger.focus();
      }
    }, 100);
  }

  // Detect when the cart drawer opens or closes
  const cartDrawerObserver = new MutationObserver(function () {
    const isOpen = cartDrawer.getAttribute("aria-hidden") === "false";

    if (isOpen) {
      focusCartDrawer();
    } else if (lastFocusedElement) {
      focusCartTrigger();
    }
  });

  cartDrawerObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["aria-hidden"]
  });

  // Save the element that opened the cart drawer
  cartDrawerTrigger.addEventListener("click", function () {
    lastFocusedElement = this;

    setTimeout(function () {
      focusCartDrawer();
    }, 100);
  });

  // Close button
  document.addEventListener("click", function (event) {
    const closeButton = event.target.closest(".js-close-drawer");

    if (!closeButton) return;

    setTimeout(function () {
      focusCartTrigger();
    }, 150);
  });

  // Escape key
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    setTimeout(function () {
      if (cartDrawer.getAttribute("aria-hidden") === "true") {
        focusCartTrigger();
      }
    }, 150);
  });


  /* =========================
     Existing Upsell Code
  ========================= */

  cartDrawerTrigger.addEventListener("click", function () {
    setTimeout(function () {
      initUpsellListeners();
    }, 1000);
  });

  function initUpsellListeners() {
    attachVariantChangeHandler();
    attachUpsellFormSubmitHandler();
  }

  function attachVariantChangeHandler() {
    document.querySelectorAll(".upsell-select").forEach(function (select) {
      if (!select.hasAttribute("data-bound")) {
        select.addEventListener("change", function () {
          const selectedVariantId = this.value;
          const form = this.closest(".upsell-form");

          if (form) {
            const hiddenInput = form.querySelector(
              'input[type="hidden"][name="id"]'
            );

            if (hiddenInput) {
              hiddenInput.value = selectedVariantId;
            }
          }
        });

        select.setAttribute("data-bound", "true");
      }
    });
  }

  function attachUpsellFormSubmitHandler() {
    const cartFormEle = document.querySelector("cart-form");

    document.querySelectorAll(".upsell-form").forEach(function (form) {
      const submitButton = form.querySelector(".upsell-add-btn");

      if (submitButton && !submitButton.hasAttribute("data-bound")) {
        submitButton.addEventListener("click", function (e) {
          e.preventDefault();

          const formData = new FormData(form);

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              Accept: "application/json"
            },
            body: formData
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error("Add to cart failed");
              }

              return response.json();
            })
            .then(function () {
              if (
                cartFormEle &&
                typeof cartFormEle.boundRefresh === "function"
              ) {
                cartFormEle.boundRefresh();
              }

              setTimeout(function () {
                initUpsellListeners();
              }, 2000);
            })
            .catch(function (error) {
              console.error("Error adding upsell product:", error);
            });
        });

        submitButton.setAttribute("data-bound", "true");
      }
    });
  }
});
